/* @flow */
// typecheck: ignore file
import React from 'react';
import ChevronBox from 'components/ChevronBox.jsx';

import './styles/ZopimChevronBox.scss';

export default function ZopimChevronBox() {
  return (
    <ChevronBox className="ZopimChevronBox" direction="right">
      Chat with Remind
    </ChevronBox>
  );
}



// WEBPACK FOOTER //
// ./src/support/components/ZopimChevronBox.jsx